import Html from './html'
import Button from './button'
import Image from './image'
import Link from './link'
import SelectLang from './select-lang'
import Modal from './modal'
import Panel from './panel'
import Tabs from './tabs'
import GridLayout from './grid-layout'
import Switch from './switch'
import Loader from './loader'
import Title from './title'
import Dropdown from './dropdown'

require('./forepaas-font/styles.less')

export default {
  'html': Html,
  'button': Button,
  'image': Image,
  'link': Link,
  'select-lang': SelectLang,
  'modal': Modal,
  'panel': Panel,
  'grid-layout': GridLayout,
  'tabs': Tabs,
  'switch': Switch,
  'loader': Loader,
  'title': Title,
  'dropdown': Dropdown
}
